 <p class="alert alert-success" *ngIf="updateMessage"> Site updated successfully!</p>  
  <p class="alert alert-danger" *ngIf="errorMessageActive">{{errorMessage}}</p> 
  <p class="alert alert-success" *ngIf="alertSuccess"> Site saved successfully!</p>    
  <p class="alert alert-danger" *ngIf="timeOutError"> {{timeoutErrorMessage}}</p>    
  <form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm" enctype="multipart/form-data">
 
  <div>
      <h5>CREATE SITE</h5>
  </div>

  <div class="col-md-3 divfloat">
    <ul class="nav flex-column nav-pills" role="tablist">
        <li class="nav-item">
          <a id="BannerImage" class="nav-link active" data-toggle="pill" href="#home">Banner Image</a>
        </li>
        <li class="nav-item">
          <a class="nav-link " data-toggle="pill" href="#menu1">Vision & Mission</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="pill" href="#menu2">Primary Contacts</a>
        </li>
      </ul>
    </div>
    <div class="tab-content divfloat col-md-8">
    <div id="home" class="container tab-pane active"><br>
      <!-- banner image tab starts -->
      <div class="form-group">
        <label class="sitelabel" for="siteName">Site Name <span class="star"> *</span></label>
        
        <input type="text" class="form-control" id="siteName" name="siteName" placeholder="Enter Site name" maxlength="50" [(ngModel)]="siteName" required>
      </div>
    
      <div class="form-group" [ngClass]="{'disabled' : locationCode == 'DFLT'}">
        <label class="sitelabel" for="locationCode">Location Code<span class="star"> *</span></label>
        
        <input type="text" class="form-control" id="locationCode" name="locationCode" [(ngModel)]="locationCode"
         onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||(event.charCode > 96 && event.charCode < 123)
          ||(event.charCode==44) || (event.charCode >= 48 && event.charCode <= 57 ) || (event.charCode >= 96 && event.charCode <= 105))' placeholder="Enter comma ' , '  separated 6 or 4 character location code" required>
      </div>

       <div class="form-group">
        <label class="sitelabel" for="siteDesc">Description <span class="star"> *</span></label>
        <textarea class="form-control" id="siteDesc" name="siteDesc" placeholder="Enter Site description" maxlength="500" [(ngModel)]="siteDesc" required></textarea>
      </div>  
     
        <div class="form-group">
          <label class="sitelabel bannerupload" for="siteBanner">Site Banner <span class="star"> *</span></label>
          <input #myInput type="file" class="form-control inputfile inputfile-6" id="siteBanner" name="siteBanner" maxlength="200" [(ngModel)]="siteBanner" (change) = "fileChangeEvent($event)" accept="image/*"  [required]="siteId == '0'" [attr.disabled]="isUploadImage == true ? true : null"> 
          <label for="siteBanner"><span id="filename">JPEG or PNG</span><strong><img *ngIf="!isUploadImage" alt="Angular Logo" src="assets/images/upload-button.png"/></strong></label>
          <textarea class="form-control base64textarea" id="base64textarea"></textarea>          
        </div>
        
            <div class="form-group" *ngIf="isUploadImage">
      <span class="sitelabel" for="siteBanner"></span>
     <div class="pull-left">
     <div class="loader_ajax_small" [hidden]="isLoaderStop"></div>
<image-cropper
  [imageChangedEvent]="imageChangedEvent"
  [aspectRatio]="1366/400"
  [maintainAspectRatio]="true"
  [resizeToWidth] = "1366"
  [resizeToHeight] = "400"
  [onlyScaleDown] = "true"
  format="png"
  (imageCropped)="imageCropped($event)"
  (imageLoaded)="imageLoaded()"
  (cropperReady)="cropperReady()"
  (loadImageFailed)="loadImageFailed()"
  [imageQuality]="92"
></image-cropper>
      </div>
     </div>
   <div class="form-group" *ngIf="isLoaderStop">
        <span class="sitelabel bannerupload" for="siteBanner"></span>
        <div class="pull-left">
        <a (click)="doneUploadedImage()"><span class="uploadImageClass"><i class="fa fa-check"></i>&nbsp;Done</span></a>
        &nbsp;&nbsp;<a (click)="cancelUploadedImage()"><span class="uploadImageClass"><i class="fa fa-close"></i>&nbsp;Cancel</span></a>
        </div>
        </div>
        
        <div class= "main-section">   
          <p class="errorMessage" *ngIf="siteNameCheck"> Site name can't be blank </p>  
          <p class="errorMessage" *ngIf="siteDescCheck"> Site description can't be blank </p> 
          <p class="errorMessage" *ngIf="siteBannerUploadCheck"> Please upload site banner </p>  
          <p class="errorMessage" *ngIf="isExistSitename"> Site name already exits </p> 
          <p class="errorMessage" *ngIf="locationCodeCheck"> Location code should be in the [MIAS],[MIAS,MACD],[MIAS01] etc format and should be of 6 or 4 character</p>  
          <p class="errorMessage" *ngIf="isExistLocationCode"> Location code already exits </p>  
          <p class="errorMessage" *ngIf="isLocationCodeUnique"> Location code must be unique </p>   
       </div>
          <p class="errorMessage" *ngIf="uploadFileExtension"> You can only upload jpg, jpeg, png files </p>
      <!-- banner Image tab close -->
    </div>
    
    <div id="menu1" class="container tab-pane fade" [ngClass]="{'disabled' : locationCode == 'DFLT'}"><br>
      <!-- vision-mission tab starts -->
      <div class="form-group">
        <label class="sitelabel" for="siteVision">Site Vision 
          <span class="star"> *</span><br>
          <span class="validation-error-message" *ngIf="siteVision != null && siteVision.length>=1024">
            Only a maximum of 1024 characters are allowed
          </span>
        </label>
        <ckeditor class="val-margin" [(ngModel)]="siteVision" #myckeditor="ngModel" name="ckeditor" placeholder="Enter Site vision" [config]="removeToolbar" [readonly]="false" maxlength="1024" required>
        </ckeditor>

      </div>

      <div class="form-group">
          <label class="sitelabel" for="siteMission">Site Mission 
            <span class="star"> *</span><br>
            <span class="validation-error-message" *ngIf="siteMission != null && siteMission.length>=1024">
              Only a maximum of 1024 characters are allowed
            </span>
          </label>
          <ckeditor class="val-margin" [(ngModel)]="siteMission" #myckeditor="ngModel" name="ckeditor1" [config]="removeToolbar" [readonly]="false" maxlength="1024" required>
          </ckeditor>

        </div> 
        <div class= "main-section">   
          <p class="errorMessage" *ngIf="visionLength"> Maximum character limit has been exceeded</p>
          <p class="errorMessage" *ngIf="visionBlankCheck"> Vision and Mission can't be blank </p>     
       </div>
       <!-- vision-mission tab close --> 
  </div><br>
  <div id="menu2" class="container tab-pane fade" [ngClass]="{'disabled' : locationCode == 'DFLT'}"><br>
    <!-- Primary Contacts tab starts -->
    <div class="form-group">
    <label class="sitelabel" for="siteContacts">Site Contacts <span class="star"> *</span> <span> (Super Admins) </span></label>  
    <div class="scrolling">
       
      <span *ngFor="let user of userList">
          <span class="col-lg-6 alignleft">
            <label>
              <input type="checkbox" required name="check" [checked]="user.checked" (change)="toggleCheckboxBpg($event,user)"><span
                class="label-text"></span>
              <span class="bpg-name bold-text">{{user.userFirstName}} {{user.userLastName}}</span>
             
            </label>
          </span><br>
        </span></div></div>
        <div class= "main-section">   
          <p class="errorMessage" *ngIf="isSiteContactsChecked"> Please select site contacts </p>
       </div> 
    <!-- Primary Contacts tab close -->
  </div><br>
  </div>
  <div class="clear"></div>
   
  <div class="btn-div">
      <button type="submit" id="siteSubmit" class="btn btn-danger" *ngIf="editandSavebtn ==false && savebtn == true" [disabled]="!myForm.valid || siteContacts==0 || uploadImageDone || uploadFileExtension">SAVE</button>
      <button type="submit" id="siteEditSubmit" class="btn btn-danger" *ngIf="editandSavebtn ==true && savebtn == false" [disabled]="!myForm.valid  || (siteContacts==0 && locationCode != 'DFLT') || uploadImageDone || uploadFileExtension">SAVE AND UPDATE</button>
  <button type="button" class="btn btn-danger" (click)="resetSite()"   data-toggle="modal" data-target="#myModal">RESET</button>
</div>
<app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
</form>


<div class="outer-div">
      <div class="searchBox">
        <label for="search">Search</label>
        <input type="text" class="form-control" id="search" maxlength="50" placeholder="Keywords here"
          [(ngModel)]="searchKey" (keyup.enter)="searchMe()">
      </div>
</div>

<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div id="tabledemo1"  *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" (click)="sortMe('siteName')">Site Name <span class="sortupdown"><i id="siteName1"
            class="fa fa-sort-up"></i><i id="siteName2" class="fa fa-sort-down"></i></span></th>
          <th scope="col">Site Description</th>
          <th scope="col">Site Vision</th>
          <th scope="col">Site Mission</th>
          <th scope="col" class="col-display">Created By </th>
          <th scope="col" class="col-display">ERG ID </th>
          <th scope="col" class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of siteData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td>{{data.siteName}}</td>
          <td>{{data.siteDesc.length > 125 ? data.siteDesc.slice(0,125)+'...' : data.siteDesc}}</td>
          <td><span [innerHtml]="data.siteVision.length > 125 ? data.siteVision.slice(0,125)+'...' : data.siteVision"></span></td>
          <td><span [innerHtml]="data.siteMission.length > 125 ? data.siteMission.slice(0,125)+'...' : data.siteMission"></span></td>
          <td class="col-display">{{data.createdBy}}</td>
          <td class="col-display">{{data.siteId}}</td>
          <td>           
            <a id="edit{{i}}" (click)="edit(data,i)" class="edit-delete"><img src="assets/images/edit.png" class="image" alt="Angular Logo" title="Edit"></a>
            <a class="edit-delete" (click)="deleteSite(data)" style="display: none">Delete</a>
          </td>
        </tr>

      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>
